import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Empty } from '../../empty';
import { ParameterList } from '../../parameter-list';
import { OperationSectionBody } from './OperationSectionBody';
import { OperationSectionHeading } from './OperationSectionHeading';
export function OperationParametersSection({ pathItem, operation }) {
    const { parameters: pathItemParameters = [] } = pathItem;
    const { parameters: operationParameters = [] } = operation;
    const parameters = [
        ...pathItemParameters,
        ...operationParameters.filter((operationParameter) => pathItemParameters.every((pathItemParameter) => operationParameter.name !== pathItemParameter.name || operationParameter.in !== pathItemParameter.in))
    ];
    return (_jsxs(_Fragment, { children: [_jsx(OperationSectionHeading, { children: "Parameters" }), _jsxs(OperationSectionBody, { children: [parameters.length === 0 && _jsx(Empty, { children: "No parameters." }), parameters.length > 0 && _jsx(ParameterList, { parameters: parameters })] })] }));
}
